import {
  useTypeSafeMutation,
  VerifyCustomerBody,
  VerifyCustomerResult,
} from '@oresundsbron/api';
import { ValidationResult } from '@oresundsbron/use-form';
import { useCallback } from 'react';

export function useVerifyCustomer() {
  const { mutateAsync } = useTypeSafeMutation(
    ['customer', 'verify'],
    (req) => req.Customer.verifyCustomerV2,
    {
      retry: 0,
    }
  );

  const verify = useCallback(
    <T>(
        verifyResultFn: (result: VerifyCustomerResult) => ValidationResult<T>
      ) =>
      async (body: VerifyCustomerBody) => {
        try {
          const response = await mutateAsync(body);
          return verifyResultFn(response);
        } catch (e) {
          return verifyResultFn({
            success: false,
          });
        }
      },
    [mutateAsync]
  );

  return verify;
}
